import React, { createContext, useEffect, useReducer } from "react";
import Reducer from "./reducer";
import { initialState } from "./initialState";
import { fetchCreditNotes } from "./service";

const Context = createContext();

const Provider = ({ children }) => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        const getCreditNotes = async () => {
            try {
                dispatch({type: 'IS_LOADING'});
                const response = await fetchCreditNotes({
                    current_page: state.current_page,
                    search_value: state.search_value
                });
    
                dispatch({
                    type: 'IS_LOADED',
                    credit_notes: response.credit_notes,
                    total_credit_notes: response.total_credit_notes,
                    total_pages: response.total_pages,
                }); 
            } catch (error) {
                console.error('Error fetching disputes:', error);
            }
        };
    
        getCreditNotes();
    }, [state.current_page, state.search_value]);
    
    return (
        <Context.Provider value={{state, dispatch}}>
            {children}
        </Context.Provider>
    );
    
}

export { Context, Provider };